var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_16495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_16495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 8.62498C10.8671 8.62498 9.90456 8.22914 9.11289 7.43748C8.32122 6.64581 7.92539 5.68331 7.92539 4.54998C7.92539 3.41664 8.32122 2.45414 9.11289 1.66248C9.90456 0.870809 10.8671 0.474976 12.0004 0.474976C13.1337 0.474976 14.0962 0.870809 14.8879 1.66248C15.6796 2.45414 16.0754 3.41664 16.0754 4.54998C16.0754 5.68331 15.6796 6.64581 14.8879 7.43748C14.0962 8.22914 13.1337 8.62498 12.0004 8.62498ZM9.77539 21.3L5.37539 16.925C4.97539 16.525 4.67122 16.0666 4.46289 15.55C4.25456 15.0333 4.15039 14.4666 4.15039 13.85C4.15039 12.65 4.57539 11.625 5.42539 10.775C6.27539 9.92498 7.30039 9.49998 8.50039 9.49998C9.08372 9.49998 9.63372 9.61248 10.1504 9.83748C10.6671 10.0625 11.1421 10.3916 11.5754 10.825L12.0004 11.25L12.4254 10.825C12.8254 10.425 13.2921 10.1041 13.8254 9.86248C14.3587 9.62081 14.9171 9.49998 15.5004 9.49998C16.7004 9.49998 17.7254 9.92498 18.5754 10.775C19.4254 11.625 19.8504 12.65 19.8504 13.85C19.8504 14.4666 19.7462 15.0333 19.5379 15.55C19.3296 16.0666 19.0254 16.525 18.6254 16.925L14.2254 21.3C13.9087 21.6 13.5587 21.8291 13.1754 21.9875C12.7921 22.1458 12.4004 22.225 12.0004 22.225C11.6004 22.225 11.2087 22.1458 10.8254 21.9875C10.4421 21.8291 10.0921 21.6 9.77539 21.3Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotional);
export default __webpack_public_path__ + "static/media/emotional.c5142e31452c36874f72239c55cc39e0.svg";
export { ForwardRef as ReactComponent };